import { collectionInvoiceType } from "./type";

const initialAuthState = {
  collectionInvoiceList: null,
  collectionInvoice: null,
  isLoading: false,
  statusCode: null
};

export const reducer = (state = initialAuthState, action) => {
  switch (action.type) {
    case collectionInvoiceType.GET_COLLECTION_INVOICE_REQUEST:
      return { ...state, isLoading: true };
    case collectionInvoiceType.GET_COLLECTION_INVOICE_SUCCESS:
      return { ...state, isLoading: false, collectionInvoiceList: action.payload.data };
    case collectionInvoiceType.GET_COLLECTION_INVOICE_FAIL:
      return { ...state, isLoading: false, error: action.error };
    case collectionInvoiceType.GET_SINGLE_COLLECTION_INVOICE_REQUEST:
      return { ...state, isLoading: true };
    case collectionInvoiceType.GET_SINGLE_COLLECTION_INVOICE_SUCCESS:
      return { ...state, isLoading: false, collectionInvoice: action.payload };
    case collectionInvoiceType.GET_SINGLE_COLLECTION_INVOICE_FAIL:
      return { ...state, isLoading: false, error: action.error };
    default:
      return state;
  }
};
